import Pagination from "features/shared/components/pagination/Pagination";
import React from "react";

interface Props {
  urlParams: URLSearchParams
  count: number;
  pageSize: number;  
  onPageChange: (pageNumber: number) => void;
}

const InvoiceGridPagination = ({
  urlParams,
  count,
  pageSize,  
  onPageChange,
}: Props) => {
  const pagesCount = count > 1 ? Math.ceil(count / pageSize) : 0;

  if (pagesCount > 1) {
    return (
      <div className="order-1 order-sm-0 mt-2 mt-sm-0">
        <Pagination
          urlParams={urlParams}
          count={count}
          pageSize={pageSize}     
          onPageChange={onPageChange}     
          useXsView
        />
      </div>
    );
  } else {
    return null;
  }
};

export default InvoiceGridPagination;